import React, { FC, ReactElement } from 'react';

import styles from './styles.module.scss';

export const TableHeader: FC = (): ReactElement => (
    <div className={styles.tableHeader}>
        <div className={styles.number}>#</div>
        <div className={styles.proposalName}>proposal name</div>
        <div className={styles.date}>date</div>
        <div className={styles.fundsRequested}>funds requested</div>
        <div className={styles.voted}>proposer choice</div>
    </div>
);
